import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { Head1 } from 'styling/Typography'
import { tokens } from 'styling/tokens'
import { IBackHeader } from 'types/ui/backHeader.interface'
import { BackHeaderRow, BackHeaderLeft, BackHeaderActions, BackBtn } from './BackHeader.styled'

export const BackHeader = ({ title, backTo, onBack, children }: IBackHeader) => {
  const navigate = useNavigate()
  const showBack = Boolean(backTo || onBack)

  const handleBack = () => {
    if (onBack) return onBack()
    if (backTo) return navigate(backTo)
    navigate(-1)
  }

  return (
    <BackHeaderRow>
      <BackHeaderLeft>
        {showBack && (
          <BackBtn type='button' onClick={handleBack} aria-label='Back'>
            <ArrowLeft />
          </BackBtn>
        )}
        <Head1 style={{ fontSize: '1.5rem', lineHeight: 1.3 }} color={tokens.text.primary}>
          {title}
        </Head1>
      </BackHeaderLeft>
      {children && <BackHeaderActions>{children}</BackHeaderActions>}
    </BackHeaderRow>
  )
}
